<div class="content-wrapper">
  <div class="row">
    <div class="col-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">New Hire Onboarding</h4>

          <form class="forms-sample" #newHireForm="ngForm"
                name="form" (ngSubmit)="newHireForm.form.valid && onSubmit()" novalidate>

            <!-- Editable fields -->
            <!-- <div class="form-group">
              <label>WorkEasy Record ID</label>
              <input type="text" class="form-control" [(ngModel)]="recordId" name="recordId" required>
            </div> -->

            <div class="form-group">
              <label>Name</label>
              <input type="text" class="form-control" [(ngModel)]="name" name="name" required>
            </div>

            <div class="form-group">
              <label>Role</label>
              <input type="text" class="form-control" [(ngModel)]="role" name="role" required>
            </div>

            <div class="form-group">
              <label>Function</label>
              <ng-select [(ngModel)]="func" name="func" placeholder="Select Function..." required >
                        <ng-option *ngFor="let f of Departments" [value]="f.name">
                            {{f.name}}
                        </ng-option>
                        </ng-select>
              <!-- <input type="text" class="form-control" [(ngModel)]="func" name="func" required> -->
            </div>
            <div class="form-group">
              <label>Location</label>
              <ng-select [(ngModel)]="location" name="location" placeholder="Select Location..." required >
                        <ng-option *ngFor="let l of Locations" [value]="l.name">
                            {{l.name}}
                        </ng-option>
                        </ng-select>
            </div>
            <!-- Line Manager Dropdown -->
            <!-- <div class="form-group">
  <label>Line Manager</label>
  <select class="form-control" [(ngModel)]="lineManager" name="lineManager" required>
    <option value="">-- Select Manager --</option>
    <option *ngFor="let mgr of managers" [value]="mgr.email">
      {{ mgr.email }}
    </option>
  </select>
</div> -->
<!-- <div class="form-group">
                        <label for="employeeEmail">Linemanager Email<span> *</span></label>
                        <ng-select [(ngModel)]="lineManager" name="lineManager" placeholder="Select lineManager Email..." required >
                        <ng-option *ngFor="let mgr of managers" [value]="mgr.email">
                            {{mgr.email}}
                        </ng-option>
                        </ng-select>
                       
                    </div> -->

                    <div class="form-group">
              <label for="employeeEmail">Linemanager Email<span> *</span></label>
              <input type="text" class="form-control" [(ngModel)]="lineManager" name="lineManager" required>
            </div>


            <!-- HRBP Dropdown -->
             <div class="form-group">
                        <label for="employeeEmail">HRBP Email<span> *</span></label>
                        <ng-select [(ngModel)]="hrbp" name="hrbp" placeholder="Select hrbp Email..." required >
                        <ng-option *ngFor="let h of hrbps" [value]="h.email">
                            {{h.email}}
                        </ng-option>
                        </ng-select>
                        <!-- <div class="alert alert-danger" *ngIf="ngNewAdhocForm.submitted && employeeEmailRef.invalid">
                        Employee name is required!
                        </div> -->
                    </div>

          <!-- <div class="form-group">
  <label>HR Business Partner</label>
  <select class="form-control" [(ngModel)]="hrbp" name="hrbp" required>
    <option value="">-- Select HRBP --</option>
    <option *ngFor="let h of hrbps" [value]="h.email">
      {{ h.email }}
    </option>
  </select>
</div> -->


            <div class="form-group">
              <label>Start Date</label>
              <input type="date" class="form-control" [(ngModel)]="startDate" name="startDate" required>
            </div>

            


            <!-- Additional fields -->
            <div class="form-group">
              <label>Email</label>
              <input type="email" class="form-control" [(ngModel)]="email" name="email" required>
            </div>

            <div class="form-group">
              <label>Phone</label>
              <input type="text" class="form-control" [(ngModel)]="phone" name="phone" required>
            </div>

            <div class="form-group">
              <label>Notes</label>
              <textarea class="form-control" [(ngModel)]="notes" name="notes"></textarea>
            </div>

            <button type="submit" class="btn btn-primary mr-2">Submit</button>
            <button type="button" class="btn btn-light">Cancel</button>
          </form>

        </div>
      </div>
    </div>
  </div>
</div>
